import { JsonSerializable } from '@/util/object/JsonSerializable'

export class OrderInfo extends JsonSerializable {
  /** @type {string} */
  #referenceLineItemId
  /** @type {string} */
  #platformHash
  /** @type {string} */
  #utid
  /** @type {Array<string>} */
  #attributes

  constructor (jsonObject) {
    super()
    if (jsonObject) {
      this.#referenceLineItemId = jsonObject.referenceLineItemId
      this.#platformHash = jsonObject.platformHash
      this.#utid = jsonObject.utid
      this.#attributes = jsonObject.attributes || []
      Object.freeze(this)
    } else {
      throw new Error('Missing OrderInfo data')
    }
  }

  /**
   * @return {string}
   */
  get referenceLineItemId () {
    return this.#referenceLineItemId
  }

  /**
   * @return {string}
   */
  get platformHash () {
    return this.#platformHash
  }

  /**
   * @return {string}
   */
  get utid () {
    return this.#utid
  }

  /**
   * @return {Array<string>}
   */
  get attributes () {
    return this.#attributes
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      referenceLineItemId: this.#referenceLineItemId,
      platformHash: this.#platformHash,
      utid: this.#utid,
      attributes: this.#attributes
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {OrderInfo|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new OrderInfo(jsonObject)) || undefined
  }

  /**
   * Builder to convert from OrderInfoResponse
   * @param {OrderInfoResponse} orderInfoResponse
   * @return {OrderInfo|undefined}
   */
  static fromOrderInfoResponseData (orderInfoResponse) {
    return (orderInfoResponse && OrderInfo.fromJSON({
      referenceLineItemId: orderInfoResponse?.referenceLineItem?.referenceLineItemId,
      platformHash: orderInfoResponse?.splitInfo?.platformHash,
      utid: orderInfoResponse?.splitInfo?.utid,
      attributes: orderInfoResponse?.item?.attributes?.map(attribute => attribute.name)
    })) || undefined
  }
}
